import { Stack, SxProps, Theme, Typography } from '@mui/material';
import { OptionalChip, RequiredChip } from 'components/chips';

type Props = {
  id?: string;
  required?: boolean;
  optional?: boolean;
  sx?: SxProps<Theme> | undefined;
  children?: React.ReactNode;
};

const FormLabel = (props: Props) => {
  const { children, sx, optional, required } = props;
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        width: '100%',
        m: '0 auto',
        textAlign: 'left',
        ...sx
      }}
    >
      <Typography variant="subtitle1">{children}</Typography>
      {required && <RequiredChip />}
      {optional && <OptionalChip />}
    </Stack>
  );
};

export default FormLabel;
